import React from "react";
import SelectForm from "../SelectForm/SelectForm";

const PMSSelect = (props) => {
  const pmsFormItem = {
    name: "pms",
    label: "PMS",
    placeholder: "Please Select PMS",
  };
  return (
    <SelectForm
      formItem={pmsFormItem}
      layOutSpan="24"
      valueKey="pms_name"
      {...props}
    />
  );
};

export default PMSSelect;
